import styled from "@emotion/styled";
import type React from "react";

import { useMedia } from "@hooks/useMedia";

interface SideBar {
  children: React.ReactNode;
  isVisible: boolean;
  onClose: () => void;
  style?: React.CSSProperties;
}

export const SideBar: React.FC<SideBar> = ({ children, isVisible, style, onClose }) => {
  const { desktop } = useMedia();
  return (
    <>
      {isVisible && <Backdrop onClick={onClose} />}
      <ModalDialog className={isVisible ? "show" : ""} desktop={desktop} role="document" style={style}>
        <RelativeContainer>{children}</RelativeContainer>
      </ModalDialog>
    </>
  );
};

const Backdrop = styled.div`
  position: fixed;
  top: 48px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
`;

const ModalDialog = styled.div<{ desktop: boolean }>`
  position: fixed;
  top: ${({ desktop }) => (desktop ? "48px" : "48px")};
  bottom: ${({ desktop }) => (desktop ? "48px" : "0px")};
  right: ${({ desktop }) => (desktop ? "-420px" : "-100%")};
  width: ${({ desktop }) => (desktop ? "400px" : "100%")};
  transition:
    opacity 0.3s linear,
    right 0.3s ease-out;
  z-index: 5;
  overflow-x: hidden;
  overflow-y: auto;
  height: calc(100% - 48px);

  &.show {
    right: 0px;
  }
`;

const RelativeContainer = styled.div`
  position: relative;
  height: 100%;
`;
